<template>
  <WdsMenu v-if="managesWorkers" placement="bottom-end" z-index="10" global>
    <template #trigger>
      <WdsButtonGhost class="tw-float-right" data-test="candidate-menu-trigger">
        <WdsIcon name="overflow-menu-horizontal" />
      </WdsButtonGhost>
    </template>

    <WdsMenuOption
      v-if="contract && contract.status === 'ACTIVE'"
      @click="$emit('show-contract-button-clicked')"
    >
      <WdsIcon name="document" :size="16" />
      <span class="tw-whitespace-nowrap">{{ $t('View Contract') }}</span>
    </WdsMenuOption>

    <WdsMenuOption v-else theme="DESTRUCTIVE" @click="showDeclineContractModal = true">
      <WdsIcon name="document" :size="16" />
      <span class="tw-whitespace-nowrap">{{ $t('Decline Contract') }}</span>
    </WdsMenuOption>

    <WdsMenuOption
      v-if="contract"
      :disabled="!contract.pdfUrl"
      :href="contract.pdfUrl"
      target="_blank"
    >
      <WdsIcon name="download" :size="16" weight="thick" />
      <span class="tw-whitespace-nowrap">{{ $t('Download contract PDF') }}</span>
    </WdsMenuOption>

    <WdsMenuOption v-if="conversation" :href="conversation.url">
      <WdsIcon name="chat" :size="16" weight="thick" />
      <span class="tw-whitespace-nowrap">{{ $t('Go to conversation') }}</span>
    </WdsMenuOption>
  </WdsMenu>

  <DeclineContractModal
    :open="showDeclineContractModal"
    :hire-id="hireId"
    :recruiter-id="recruiterId"
    @close="showDeclineContractModal = false"
    @hire-canceled="$emit('hire-canceled')"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { WdsButtonGhost, WdsIcon, WdsMenu, WdsMenuOption } from '@worksome/wds-components'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import DeclineContractModal from '@/components/Hire/DeclineContractModal.vue'

type Contract = {
  id: string
  status: string
  pdfUrl?: string
}

type Conversation = {
  id: string
  url: string
}

defineProps<{
  hireId: string
  recruiterId: string
  managesWorkers: boolean
  contract: Contract
  conversation: Conversation
}>()

defineEmits(['show-contract-button-clicked', 'hire-canceled'])

const showDeclineContractModal = ref(false)
</script>
